module.exports = __webpack_public_path__ + "static/media/amazon-preview.de43b221.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/amazon-preview.jpg
// module id = 658
// module chunks = 0